import React, { useEffect, useState } from 'react';
import { Button, Image, Modal } from 'react-bootstrap';
import StarRating from 'react-star-ratings';
import { useSearchParams, useNavigate } from 'react-router-dom';

import IFeedbackData from '../interfaces/IFeedbackData';

import api from '../services/apiClient';

import StatusFeedbackBomIcon from '../assets/icon/statusFeedbackBom.svg';
import StatusFeedbackMedioIcon from '../assets/icon/statusFeedbackMedio.svg';
import StatusFeedbackRuimIcon from '../assets/icon/statusFeedbackRuim.svg';
import ArrowRightCircle from '../assets/icon/arrowRightCircle.svg';

import ButtonDotsIcon from '../assets/icon/buttonDots.svg';

const DashboardResume = ({
  atendimentoData,
}: {
  atendimentoData: IFeedbackData[];
}): JSX.Element => {
  const [dataTexto, setDataTexto] = useState('');
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  function handleShowDetailFeedback(id: number): any {
    if (id) {
      // Criar uma nova instância de URLSearchParams a partir da URL atual
      const newParams = new URLSearchParams(window.location.search);

      // Definir o novo valor para o parâmetro 'id'
      newParams.set('id', id.toString());

      // Passar o novo objeto URLSearchParams diretamente para setSearchParams
      setSearchParams(newParams);
    }
  }

  const showIconFeedback = (avaliacao: number): string => {
    if (avaliacao <= 2) return StatusFeedbackRuimIcon;
    if (avaliacao <= 3) return StatusFeedbackMedioIcon;
    return StatusFeedbackBomIcon;
  };

  return (
    <div className="d-flex flex-column" style={{ height: '100px' }}>
      <Modal
        centered
        show={dataTexto?.length > 0}
        onHide={() => setDataTexto('')}
      >
        <Modal.Body>{dataTexto}</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => setDataTexto('')}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>

      {atendimentoData?.map((avaliacao: IFeedbackData) => (
        <div key={avaliacao.seqAtendimento} className="d-flex ms-3 py-2">
          <Image
            style={{ height: '4rem', width: '4rem' }}
            src={showIconFeedback(avaliacao.avaliacao)}
          />
          <div className="ms-3 " style={{ fontSize: '1.25rem' }}>
            <div className="d-flex" style={{ fontWeight: '600' }}>
              <span className="pt-1 pe-2">
                {avaliacao.nomeCliente?.length > 30
                  ? avaliacao.nomeCliente.substring(0, 30)
                  : avaliacao.nomeCliente}
                {avaliacao.nomeCliente?.length > 30 && (
                  <Image
                    style={{ cursor: 'pointer' }}
                    className="ms-1"
                    src={ButtonDotsIcon}
                    alt="Nome do cliente"
                    onClick={() => setDataTexto(avaliacao?.nomeCliente)}
                  />
                )}
              </span>
              <StarRating
                name="react-star-rating"
                numberOfStars={5}
                rating={avaliacao.avaliacao}
                starRatedColor="#ffc107"
                starEmptyColor="#ced4da"
                starHoverColor="#ffc107"
                starDimension="1.4rem"
              />
              <span className="pt-1 ms-2">{`(${avaliacao.avaliacao},0)`}</span>
            </div>
            <span className="pt-1">
              {avaliacao?.comentario?.length > 50
                ? `${avaliacao?.comentario?.substring(0, 50)}`
                : avaliacao?.comentario}
              <Image
                style={{ cursor: 'pointer' }}
                className="ms-1"
                src={ButtonDotsIcon}
                alt="Comentário"
                hidden={
                  avaliacao?.comentario === null || avaliacao?.comentario === ''
                }
                onClick={() => setDataTexto(avaliacao?.comentario)}
              />
            </span>
          </div>
          <div
            style={{ flex: 1 }}
            className="d-flex align-items-center justify-content-end me-2"
            onClick={() => {
              handleShowDetailFeedback(avaliacao.seqAtendimento);
              navigate(
                `/Feedback?principal=false&id=${avaliacao.seqAtendimento}`
              );
            }}
            onKeyDown={() => {
              // setFeedbackSelected(avaliacao);
              // setShowDetail(true);
            }}
            role="button"
            tabIndex={0}
          >
            <div className="bg-primary p-1 border rounded-circle">
              <Image
                src={ArrowRightCircle}
                alt="Seta direita"
                style={{ height: '1.5rem', width: '1.5rem' }}
              />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default DashboardResume;
